import { gql } from '@apollo/client';

export const NEW_VERIFICATION_WITH_PARAM = gql`
    query NewVerification(
        $externalId: String!
    ) {
        newVerification(externalId: $externalId) {
            externalId
            publicId
            plans {
                id
                name
            }
        }
    }
`;